import { ClassData } from "../../../common/dtos/classes.type";
import RYBConnectClasses from "../../../common/services/classes.service";
import { DEFAULT_CATEGORY } from "../../../common/services/default-category.service";
import {
  RYB_CLASSES_DATA,
  URL_PARAMETERS,
} from "../../../common/utils/const.util";
import {
  filterByAge,
  filterByKeyAndValue,
} from "../../../common/utils/filters.util";
import { getUniqueLocationsList } from "../../../common/utils/locations.util";
import {
  getAllParamsFromURL,
  getUrlParameterValue,
  modifyUrlParameter,
  setUrlParameter,
} from "../../../common/utils/url.util";
import { setResultGridView } from "./result-grid.view";

export function setFilterTopView() {
  if (ryb_connect_classes_data.wizard.steps["2"].length) {
    hideOldFields();
    setNewFields();
  }

  if ($(".edit-option.locations .dropdown.locations")) {
    setLocationsDropdownList();
    // ugly hack but no time
    // caused due to the race condition when setting elements
    setTimeout(() => {
      editBoxFunctionality();
    }, 1000);
    setClassTypeEditList();
  } else {
    setClassTypeEditList();
    editBoxFunctionality();
  }
}

function hideOldFields() {
  const wrapper = document.querySelector("#class-finder .filter-top");
  if (wrapper) {
    const locations = wrapper.querySelector(".edit-option.locations");
    if (locations) {
      locations.remove();
    }
    const age = wrapper.querySelector(".edit-option.age");
    if (age) {
      age.remove();
    }
    const gender = wrapper.querySelector(".edit-option.gender");
    if (gender) {
      gender.remove();
    }
  }
}

function setNewFields() {
  const wrapper = document.querySelector(
    "#class-finder .filter-top .filter-controls"
  );

  if (wrapper) {
    ryb_connect_classes_data.wizard.steps["2"].forEach((item) => {
      const logoDiv = document.createElement("div");
      logoDiv.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.5652 1.6709C11.9773 1.6709 11.3897 1.89335 10.9449 2.33822L4.27658 9.00651C3.96835 9.31474 3.75419 9.70497 3.65972 10.1304L2.09803 17.1559C2.07509 17.2587 2.07847 17.3655 2.10785 17.4666C2.13722 17.5677 2.19165 17.6597 2.26608 17.7341C2.34052 17.8086 2.43254 17.863 2.53362 17.8924C2.6347 17.9217 2.74156 17.9251 2.84429 17.9022L9.86984 16.3405C10.2952 16.246 10.6855 16.0327 10.9937 15.7244L17.6628 9.05534C18.552 8.16554 18.5516 6.70438 17.662 5.81478L14.1854 2.33822C13.7406 1.89335 13.153 1.6709 12.5652 1.6709ZM5.26535 9.78532C5.42932 9.87718 5.58058 9.98662 5.71375 10.1198C6.16167 10.5681 6.31185 11.1242 6.34852 11.5692C6.79352 11.6063 7.34875 11.7552 7.79709 12.2031C8.245 12.6515 8.39519 13.2075 8.43185 13.6525C8.87685 13.6896 9.43209 13.8385 9.88042 14.2865C10.0132 14.4194 10.1229 14.5714 10.2149 14.7357L10.1099 14.8407C9.96981 14.9808 9.79261 15.0776 9.59885 15.1206L6.69439 15.766L4.23507 13.3066L4.88042 10.4014C4.92345 10.2076 5.02026 10.0304 5.16037 9.8903L5.26535 9.78532Z"/>
                          </svg>`;
      const dropdownDiv = document.createElement("div");
      dropdownDiv.className = `edit-option ${item.query_parameter}`;

      const labelWrapperDiv = document.createElement("div");
      const labelDiv = document.createElement("div");
      labelDiv.className = "label";
      labelDiv.innerText = item.label;
      const valueDiv = document.createElement("div");
      valueDiv.className = "value";
      valueDiv.textContent = "";
      const urlParameter = getUrlParameterValue(item.query_parameter);
      if (urlParameter) {
        valueDiv.textContent =
          item.options.find((option) => option.option_value === urlParameter)
            ?.option_label || "";
      } else {
        valueDiv.innerText =
          item.options.find((option) => option.is_default === "1")
            ?.option_label || "";
      }
      const dropdownOptionsDiv = document.createElement("div");
      dropdownOptionsDiv.className = `dropdown ${item.query_parameter}`;
      const dropdownOptionsUl = document.createElement("ul");

      item.options.forEach((option) => {
        const listOption = document.createElement("li");
        listOption.innerText = option.option_label;
        listOption.setAttribute(
          "value",
          option.option_value === "null" || option.option_value === ""
            ? ""
            : option.option_value
        );
        dropdownOptionsUl.appendChild(listOption);
      });
      dropdownOptionsDiv.appendChild(dropdownOptionsUl);
      labelWrapperDiv.appendChild(labelDiv);
      labelWrapperDiv.appendChild(valueDiv);
      dropdownDiv.appendChild(labelWrapperDiv);
      dropdownDiv.appendChild(logoDiv);
      dropdownDiv.appendChild(dropdownOptionsDiv);
      const classDiv = wrapper.querySelector(".edit-option.class");
      wrapper.insertBefore(dropdownDiv, classDiv);
    });
  }
}

function editBoxFunctionality() {
  $(".filter-top .edit-option").on("click", function (event) {
    event.stopPropagation();
    if ($(this).hasClass("active")) {
      $(".filter-top .edit-option").removeClass("active");
      return;
    }
    $(".filter-top .edit-option").removeClass("active");
    $(this).addClass("active");
  });

  $(document).on("click", function () {
    $(".filter-top .edit-option").removeClass("active");
  });

  $(".filter-top .edit-option:not(.class) .dropdown ul li").on(
    "click",
    function (event) {
      event.stopPropagation();
      const selectedValue = $(this).attr("value");
      const selectedText = $(this).text();
      const $editOption = $(this).closest(".edit-option");
      const $ul = $(this).closest("ul");
      $ul.find("li").removeClass("select");

      if (selectedValue) {
        $(this).addClass("select");
      }

      $editOption.find(".value").text(selectedText);
      const classes = $editOption?.attr("class")?.split(" ");
      const className =
        classes?.find((cls) => cls !== "edit-option" && cls !== "active") || "";

      setEventClicking(selectedValue, className);
      $editOption.removeClass("active");
    }
  );
}

function setEventClicking(value: string | undefined, className: string) {
  const classManager = new RYBConnectClasses();
  if ($(`.edit-option.${className}`).hasClass("active")) {
    if (value) {
      setUrlParameter(className, value);
    } else {
      const url = new URL(window.location.href);
      url.searchParams.delete(className);
      history.pushState({}, "", url);
    }
    classManager
      .getFilteredDataByURLParams()
      .then((response) => {
        setResultGridView(response);
        setClassTypeEditList();
      })
      .catch((_error) => {
        $("#ryb-openings-result").html(
          `<p class="display:block">Error: Unable to fetch class openings - edit option age.</p>`
        );
      });
  }

  if (!ryb_connect_classes_data.wizard.steps["2"].length) {
    if ($(".edit-option.locations").hasClass("active")) {
      if (value) {
        setUrlParameter(URL_PARAMETERS.LOCATION, value);
      } else {
        const url = new URL(window.location.href);
        url.searchParams.delete(URL_PARAMETERS.LOCATION);
        history.pushState({}, "", url);
      }
      classManager
        .getFilteredDataByURLParams()
        .then((response) => {
          setResultGridView(response);
          setClassTypeEditList();
        })
        .catch((_error) => {
          $("#ryb-openings-result").html(
            `<p class="display:block">Error: Unable to fetch class openings.</p>`
          );
        });
    }
  }
}

export function setLocationsDropdownList() {
  const classManager = new RYBConnectClasses();
  classManager.getData().then((response) => {
    if (!response) return;

    const availableLocations = getUniqueLocationsList(response, "short");
    const locationSelect = document.querySelector(
      ".edit-option.locations .dropdown.locations ul"
    );

    availableLocations.forEach((location) => {
      const option = document.createElement("li");
      option.setAttribute("value", location.value); // Use data attribute instead
      option.textContent = location.label;

      locationSelect?.appendChild(option);
    });
  });
}

export function setClassTypeEditList() {
  const classManager = new RYBConnectClasses();

  classManager
    .getData()
    .then((response) => {
      if (!response) return;
      const filters = getAllParamsFromURL();
      if (!filters) {
        return response;
      }
      // clear unnecessary filters
      if (filters) {
        delete filters[URL_PARAMETERS.STEP];
        delete filters[URL_PARAMETERS.USER];
        delete filters[URL_PARAMETERS.CONTACT];
        delete filters[URL_PARAMETERS.FULL_CLASSES];
        delete filters[URL_PARAMETERS.CATEGORY];
      }
      let data = structuredClone(response) || [];
      for (const [key, value] of Object.entries(filters)) {
        if (key) {
          if (key === URL_PARAMETERS.AGE) {
            data = filterByAge(data);
          }
          if (key === URL_PARAMETERS.GENDER) {
            data = filterByKeyAndValue(data, key, value);
          }
        }
      }
      data.filter((item) => item.location !== "HAM"); // REALLY WRONG - FIX WHEN YOU HAVE TIME
      editListFunctionality(data);
      updateDropdownValuesFromURL();
    })
    .catch((_error) => {
      $("#ryb-openings-result").html(
        `<p class="display:block">Error: Unable to fetch class openings - set class type edit list.</p>`
      );
    });
}

export function editListFunctionality(response: ClassData[]) {
  const classManager = new RYBConnectClasses();

  const $dropdownContainer = $(".edit-option.class .dropdown.classes");
  let $ul = $("<ul>");
  $dropdownContainer.empty().append($ul);

  const uniqueCategories = Array.from(
    new Set(response.map((item) => item[DEFAULT_CATEGORY]))
  ).map((uniqueValue) => {
    return response?.find((item) => item[DEFAULT_CATEGORY] === uniqueValue);
  });
  const availableCategories = uniqueCategories.map((location) => ({
    label: location?.name,
    value: location?.[DEFAULT_CATEGORY],
  }));

  const urlParams = new URLSearchParams(window.location.search);
  const selectedCategories = urlParams.getAll("category")?.length
    ? urlParams.getAll("category")[0].split(",")
    : [];

  $ul.append($("<li>").attr("value", "").text("All selected"));

  availableCategories.forEach((category) => {
    const constCurrentClassData = RYB_CLASSES_DATA.classes?.find(
      (category2) => category2.name === category.value
    );
    if (constCurrentClassData?.status === "Hide") {
      return;
    }
    const $li = $("<li>")
      .attr("value", category.value || "")
      .text(constCurrentClassData?.display_name || category?.value || "")
      .addClass("filterable-category");

    if (selectedCategories.includes(category.value || "")) {
      $li.addClass("select");
    }

    $ul.append($li);
  });

  $ul.on("click", "li", function () {
    const selectedValue = $(this).attr("value");
    if ($(this).hasClass("select")) {
      $(this).removeClass("select");
    } else {
      $(this).addClass("select");
    }

    modifyUrlParameter(
      $(this).hasClass("select"),
      selectedValue || "",
      URL_PARAMETERS.CATEGORY
    );

    $(this)
      .closest(".dropdown.classes")
      .closest(".edit-option.class")
      .removeClass("active");

    const selectedItems = document.querySelectorAll(
      ".filter-top .edit-option.class li.select"
    );

    if (selectedValue) {
      if (selectedItems.length) {
        $(this)
          .closest(".dropdown.classes")
          .closest(".edit-option.class")
          .find(".value")
          .text(`${selectedItems.length} Selections`);
      } else {
        unsetClassTypeList(selectedItems, this);
      }
    } else {
      unsetClassTypeList(selectedItems, this);
    }

    classManager
      .getFilteredDataByURLParams()
      .then((response) => {
        setResultGridView(response);
      })
      .catch((_error) => {
        $("#ryb-openings-result").html(
          `<p class="display:block">Error: Unable to fetch class openings - li something.</p>`
        );
      });
  });

  // Filter and update visible categories
  const visibleCategories = Array.from(
    new Set(response.map((item) => item[DEFAULT_CATEGORY]))
  );

  $ul.find(".filterable-category").each(function () {
    const categoryValue = $(this).attr("value") || "";

    // Hide or show based on current filtered response
    if (visibleCategories.includes(categoryValue)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  // Update dropdown text based on selected visible items
  const selectedItems = $ul.find("li.select:visible");
  if (selectedItems.length) {
    $(".edit-option.class .value").text(`${selectedItems.length} Selections`);
  } else {
    $(".edit-option.class .value").text("All selected");
  }
}

function unsetClassTypeList(selectedItems: NodeListOf<Element>, element: any) {
  selectedItems.forEach(function (item) {
    item.classList.remove("select");
  });
  $(element)
    .closest(".dropdown.classes")
    .closest(".edit-option.class")
    .find(".value")
    .text(`All selected`);

  const url = new URL(window.location.href);
  url.searchParams.delete(URL_PARAMETERS.CATEGORY);
  history.pushState({}, "", url);
}

function updateDropdownValuesFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const genderParam = urlParams.get("gender");
  if (genderParam) {
    const $genderDropdown = $(".edit-option.gender .dropdown.gender ul");
    const $selectedGenderItem = $genderDropdown.find(
      `li[value="${genderParam}"]`
    );

    if ($selectedGenderItem.length) {
      $genderDropdown.find("li").removeClass("select");
      $selectedGenderItem.addClass("select");
      $(".edit-option.gender .value").text($selectedGenderItem.text());
    }
  }

  const ageParam = urlParams.get("age");
  if (ageParam) {
    const $ageDropdown = $(".edit-option.age .dropdown.age ul");
    const $selectedAgeItem = $ageDropdown.find(`li[value="${ageParam}"]`);

    if ($selectedAgeItem.length) {
      $ageDropdown.find("li").removeClass("select");
      $selectedAgeItem.addClass("select");
      $(".edit-option.age .value").text($selectedAgeItem.text());
    }
  }

  const locationsParam = urlParams.get("location");
  if (locationsParam) {
    const $locationDropdown = $(
      ".edit-option.locations .dropdown.locations ul"
    );
    const $selectedLocationItem = $locationDropdown.find(
      `li[value="${locationsParam}"]`
    );

    if ($selectedLocationItem.length) {
      $locationDropdown.find("li").removeClass("select");
      $selectedLocationItem.addClass("select");
      $(".edit-option.locations .value").text($selectedLocationItem.text());
    }
  }
  const categoryParams = urlParams.getAll("category")?.length
    ? urlParams.getAll("category")[0].split(",")
    : [];

  if (categoryParams.length) {
    const $classDropdown = $(".edit-option.class .dropdown.classes ul");
    categoryParams.forEach((category) => {
      const $selectedClassItem = $classDropdown.find(`li[value="${category}"]`);

      if ($selectedClassItem.length) {
        $selectedClassItem.addClass("select");
      }
    });

    $(".edit-option.class .value").text(`${categoryParams.length} Selections`);
  }
}
